import { useRecordContext } from 'react-admin';
import { Box, Grid, Stack, Typography } from '@mui/material';
import startCase from 'lodash/startCase';
import type { OneOffCheckReport } from '@/pages/Candidate/view/tables/OneOffChecksTable/types';
import CopyToClipboard from '@/pages/components/CopyToClipboard';
import { GridRowSx } from './styled';

const OneOffCheckReportExpand = () => {
  const record = useRecordContext<OneOffCheckReport>();
  const fields = record?.custom_fields?.filter((f) => (f.label?.trim() ?? '') !== '' || f.value != null) ?? [];

  if (!fields.length) {
    return (
      <Box sx={{ py: 2, px: 2, bgcolor: 'action.hover' }}>
        <Typography variant="body2" color="text.secondary">
          No custom fields
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ py: 2, px: 2, bgcolor: 'action.hover' }}>
      <Stack spacing={0.25}>
        {fields.map((f, i) => (
          <Grid key={`${f.label ?? 'field'}-${i}`} container spacing={2} sx={GridRowSx}>
            <Grid size={3}>
              <Typography component="span" variant="body2" fontWeight={600} sx={{ wordBreak: 'break-word' }}>
                {startCase(f.label || '')}
              </Typography>
            </Grid>
            <Grid size={6}>
              <CopyToClipboard label={f.label ?? ''} value={f.value ?? ''}>
                <Typography component="span" variant="body2" sx={{ wordBreak: 'break-word' }}>
                  {f.value ?? '—'}
                </Typography>
              </CopyToClipboard>
            </Grid>
          </Grid>
        ))}
      </Stack>
    </Box>
  );
};

export default OneOffCheckReportExpand;
